import { useEffect, useState } from 'react';
import TeamService from '../services/TeamService';

let cached = null;

/** The list of access an owner can grant (name and explanation). Loaded once per page load. */
export default function useCatalog() {
  const [catalog, setCatalog] = useState(cached || []);
  useEffect(() => {
    if (cached) return undefined;
    let cancelled = false;
    TeamService.catalog().then((c) => { cached = c; if (!cancelled) setCatalog(c); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  return catalog;
}
